import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';
import { logEvent } from '@cbhq/client-analytics';
import type { Environment } from '@cbhq/idv-sdk-web';
import IdvSDK from '@cbhq/idv-sdk-web';

const environment = (process.env.TARGET_ENV ?? 'development') as Environment;

const captureConfig = { onfidoSdkVersion: 'v14.53.1' };

function handleApiError(error: Error) {
  // eslint-disable-next-line no-console
  console.error('IDV API error:', error);
}

export function TokenRoute() {
  const { token } = useParams();

  if (!token) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <VStack alignItems="center" justifyContent="center" height="100vh">
        <IdvSDK
          token={token}
          track={logEvent}
          onApiError={handleApiError}
          environment={environment}
          locale="en"
          captureConfig={captureConfig}
        />
      </VStack>
    </Suspense>
  );
}
